import React from "react";
import { motion } from "framer-motion";

const TreatmentsIntro = ({
  img,
  title,
  description,
  subheading,
  item = [],
}) => {

const containerVariant = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const fadeLeft = {
  hidden: {
    opacity: 0,
    x: -50,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};

const fadeRight = {
  hidden: {
    opacity: 0,
    x: 50,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 25,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: "easeOut",
    },
  },
};

const listItemVariant = {
  hidden: {
    opacity: 0,
    y: 15,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
    },
  },
};

  return (
    <motion.section
      className="treatment-intro-section container"
      variants={containerVariant}
      initial="hidden"
      whileInView="visible"
      viewport={{
        once: true,
        amount: 0.15,
      }}
    >

      {/* LEFT IMAGE */}

      <motion.div
        className="treatment-intro-image"
        variants={fadeLeft}
      >
        <motion.img
          src={img}
          alt={`${title} | Dr. Jigar Gor's Ayurveda`}
          whileHover={{
            scale: 1.04,
          }}
          transition={{
            duration: 0.8,
          }}
        />
      </motion.div>

      {/* RIGHT CONTENT */}

      <motion.div
        className="treatment-intro-content"
        variants={fadeRight}
      >

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          {title}
        </motion.h2>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          {description}
        </motion.p>

        <motion.h3
          className="card-heading"
          variants={fadeUp}
        >
          {subheading}
        </motion.h3>

        <motion.ul
          className={`treatment-intro-list ${
            item.length >= 10
              ? "five-col"
              : "four-col"
          }`}
          variants={containerVariant}
        >
          {item.map((listItem, index) => (
            <motion.li
              className="treatment-intro-item section-text"
              key={index}
              variants={listItemVariant}
            >
              {listItem}
            </motion.li>
          ))}
        </motion.ul>

      </motion.div>

    </motion.section>
  );
};

export default TreatmentsIntro;